export function updateLoading ({commit}, loading) {
  return commit('UPDATE_LOADING', loading)
}
export function updateDirection ({commit}, direction) {
  return commit('UPDATE_DIRECTION', direction)
}
// // 设置用户信息
// export function setUserInfo ({ commit }, userInfo) {
//   return commit('SET_USERINFO', userInfo)
// }



// WEBPACK FOOTER //
// ./src/store/actions.js